import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import StartNetworkingGroup from '../../StartNetworkingGroup/StartNetworkingGroup';
import StepViewChats from './StepViewChats';
import StepConfirmMeetings from './StepConfirmMeetings';
import StepViewMeetings from './StepViewMeetings';
import icon from './icon.png';
import styles from './ChatGroup.module.scss';
import LoadChatSessions from '../../../../loaders/LoadChatSessions';
import LoadMeetings from '../../../../loaders/LoadMeetings';
import { useEventMeetingsEnabled } from '../../../../../data/hooks/eventFeatures/useEventMeetingsEnabled';
import { useEventChatEnabled } from '../../../../../data/hooks/eventFeatures/useEventChatEnabled';

function ChatGroup(props) {
    const { eventId } = props,
        i18n = useI18n(),
        meetingsEnabled = useEventMeetingsEnabled(),
        chatsEnabled = useEventChatEnabled();

    if (!meetingsEnabled && !chatsEnabled) {
        return null;
    }

    return (
        <LoadChatSessions>
            <LoadMeetings eventId={eventId}>
                <StartNetworkingGroup name={i18n['start.chat_and_meet']} description={i18n['start.chat_and_meet.intro']} icon={icon} iconClassName={styles.icon}>
                    <StepViewChats eventId={eventId} />
                    <StepViewMeetings eventId={eventId} />
                    <StepConfirmMeetings eventId={eventId} />
                </StartNetworkingGroup>
            </LoadMeetings>
        </LoadChatSessions>
    );
}

export default ChatGroup;
